import { Component } from '@angular/core';
import { Train } from 'src/app/models/train.model';
import { TrainService } from 'src/app/services/trains/trains.service';
import { Plant } from 'src/app/models/plant.model';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Warrantycondition } from 'src/app/models/warrantycondition.model';
import { warrantyconditionService } from 'src/app/services/warrantyconditions/warrantycondition.service';
import { Unit } from 'src/app/models/unit.interface';
import {
  PagingHeader,
  QueryStringParameters,
} from 'src/app/shared/shared.model';

@Component({
  selector: 'app-list-warranty',
  templateUrl: './list-warranty.component.html',
  styleUrls: ['./list-warranty.component.scss']
})
export class ListWarrantyComponent {
  dtoptions: DataTables.Settings = {};
 
  trains: Train[] = [];
  plants: Plant[] = [];
  plantDetails: Plant = new Plant();
  warranty: Warrantycondition[]=[];
  allTrainList: Train[] = [];
  warrantyList: Warrantycondition[]=[];
  showTable = false;
  showdivselect = false;
  showName=false;
  SelectedId: string;
  trainId:string;
  showDvUnit = false;
  trainDetails: Train = new Train();

  queryParams: QueryStringParameters = new QueryStringParameters();
  public units: Array<Unit> = [
    { Id: 0, UnitName: 'Metric' },
    { Id: 1, UnitName: 'English' },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private trainService: TrainService,
    private plantService: PlantsService,
    private warrantyconditionService : warrantyconditionService
  ) {}
  getSelectedId(e) {
   
    this.showTable = true;
    this.SelectedId = e.target.value;

    this.plantService.getPlant(this.SelectedId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log(this.plantDetails);
      },
    });
    
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.allTrainList = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );



  }
  getSelectedTrainId(e)
  {
    this.showDvUnit = false;
    this.trainId=e.target.value;
    
    this.warrantyconditionService.getwarrantiesByTrainId(this.trainId).subscribe(
     {
      next: (warrantycondition) => {
        this.warrantyList = warrantycondition;
        console.log( this.warrantyList);
      },
      error: (response) => {
        console.log(response);
      },
     }
    )
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
        console.log(this.trainDetails);
        this.showDvUnit = true;
      },
    });
  }
  navigate(TId){
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['component/warrantycondition/edit/' + id]);
  }

  warrantiesgraph(Tid,Pid,PName,Wid){
    console.log(Tid,Pid,PName,Wid);
    
    this.router.navigate([
      '/component/trains/edit/warrantyC.TrainId/warrantiesgraph'
    ],{queryParams: {
      trainId: btoa(Tid.toString()),
      plantId: btoa(Pid.toString()),
      plantName: btoa(PName.toString()),
      warrantyId: btoa(Wid.toString())
    }});
    

  }
  ngOnInit(): void {
    this.route.paramMap.subscribe({
    next: (params) => {
      const enId = params.get('id');
      const id = atob(params.get('id')!);
      console.log(id);
      if (enId != null) {
        this.showdivselect = true;
        this.warrantyconditionService.getwarrantiesByTrainId(id).subscribe(
          {
           next: (warrantycondition) => {
             this.warrantyList = warrantycondition;
             console.log( this.warrantyList);
           },
           error: (response) => {
             console.log(response);
           },
          }
         )
         this.trainService.getTrainById(id).subscribe({
          next: (response) => {
            this.trainDetails = response;
            this.showDvUnit=true
            this.showName=true;
          },
        });
      }
    }
    })

    this.dtoptions = {
      pagingType: 'full_numbers',
    };

    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
       
      },
    });
  }

    //subscribe to selected train changes to update the table accordingly
    this.plantService.selectedTrain$.subscribe(trainId => {
      if (trainId) {
        this.getSelectedTrainId({
          target: {
            value: trainId
          }
        });
      }
    });
}
}